import React, { useContext, useState } from "react";
import { useFormik, Form, FormikProvider } from "formik";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Box,
  Grid,
  Stack,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import moment from "moment";
import "../../Style/dialogstyle.scss";
import { useMutation } from "@apollo/client";
import { BiMinusCircle } from "react-icons/bi";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import { CREATE_CLOSE_INCOME_SHIFT } from "../../Schema/IncomeBill";

export default function CloseIncomeShift({
  open,
  editData,
  handleClose,
  // setRefetch,
}) {
  // Change Language
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);

  const [closeIncomeShift] = useMutation(CREATE_CLOSE_INCOME_SHIFT, {
    onCompleted: ({ closeIncomeShift }) => {
      setLoading(false);
      if (closeIncomeShift?.status === true) {
        setAlert(true, "success", closeIncomeShift?.message);
        handleClose();
        // setRefetch();
      } else {
        setAlert(true, "error", closeIncomeShift?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const formik = useFormik({
    initialValues: {},
    onSubmit: async () => {
      setLoading(true);
      closeIncomeShift({
        variables: {
          id: editData?._id,
        },
      });
    },
  });

  const { handleSubmit } = formik; 
  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">Close Shift</Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" spacing={1}>
            <Typography className="field-title">Shift Date</Typography>
            <Typography className="field-title"> Open Time </Typography>
            <Typography className="field-title"> Open By </Typography>
          </Stack>
          <Stack direction="column" spacing={1}>
            <Typography className="field-title"> : </Typography>
            <Typography className="field-title"> : </Typography>
            <Typography className="field-title"> : </Typography>
          </Stack>
          <Stack direction="column" spacing={1}>
            <Typography
              className="field-title"
              sx={{ color: "black !important" }}
            >
              {moment(`${editData?.shiftDate}`).format("dddd, DD-MMM-YYYY")}
            </Typography>

            <Typography
              className="field-title"
              sx={{ color: "black !important" }}
            >
              {moment(editData?.openTime).isSame(editData?.shiftDate, "day")
                ? moment(editData?.openTime).format("hh:mm A")
                : moment(editData?.openTime).format(
                  "dddd, DD-MMM-YYYY , hh:mm A"
                )}
            </Typography>
            <Typography
              className="field-title"
              sx={{ color: "black !important" }}
            >
              {editData?.openShiftBy?.lastName}
            </Typography>
          </Stack>
        </Stack>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button className="btn-delete" fullWidth type="submit">
                    Close Shift
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
